import { AbstractControl, AbstractControlDirective, FormGroup, ValidationErrors, ValidatorFn } from "@angular/forms";

export function normalizeNullable<T>(value: T | null | undefined): T | null {
    if (value === null || value === undefined) return null;
    if (typeof value === 'string' && value.trim() === '') return null;
    return value;
}

export function cleanNum(val: any): number {
    const parsed = parseFloat(val);
    return isNaN(parsed) ? 0 : parsed;
};
export function parseSafariSafeDate(raw: string | null | undefined): Date | null {
  if (!raw) return null;
  const [datePart, timePart = '00:00:00'] = raw.split('T');

  const [year, month, day] = datePart.split('-').map(Number);
  const [hour, minute, second] = timePart.split(':').map(Number);

  return new Date(
    year,
    month - 1,
    day,
    hour,
    minute,
    second || 0
  );
}
export function normalizeNullableToString(value: any): string | null {
    if (value === null || value === undefined) return null;
    const strValue = String(value).trim();
    return strValue === '' || strValue === 'null' ? null : strValue;
}

export function formatLocalDate(date: Date | string | null): string | null {
    if (!date) return null;
    const d = new Date(date);

    // Method 1: Format as YYYY-MM-DDTHH:mm:ss (Local)
    // We offset the date by the timezone difference before calling toISOString
    const userTimezoneOffset = d.getTimezoneOffset() * 60000;
    return new Date(d.getTime() - userTimezoneOffset).toISOString();
}
export function formatLocalDDate(date: Date | string | null): Date | null {
    if (!date) return null;
    const d = new Date(date);

    // Method 1: Format as YYYY-MM-DDTHH:mm:ss (Local)
    // We offset the date by the timezone difference before calling toISOString
    const userTimezoneOffset = d.getTimezoneOffset() * 60000;
    return new Date(d.getTime() - userTimezoneOffset);
}

export function formatDateOnly_Old(date: any): string | null {
    if (!date) return null;   
    const d = new Date(date);
    d.setMinutes(d.getMinutes() - d.getTimezoneOffset());   
    return d.toISOString().split('T')[0];
  }

  export function formatDateOnly(date: any): string | null {
    if (!date) return null;
   
    const d = new Date(date);
    if (isNaN(d.getTime())) {
      return null; 
    }
    const year = d.getFullYear();
    const month = ('0' + (d.getMonth() + 1)).slice(-2);
    const day = ('0' + d.getDate()).slice(-2);
   
    return `${year}-${month}-${day}`;
  }

  export function formatDateTime(date: any): string | null {
    if (!date) return null;
    const d = new Date(date);
    if (isNaN(d.getTime())) return null;
    const year    = d.getFullYear();
    const month   = ('0' + (d.getMonth() + 1)).slice(-2);
    const day     = ('0' + d.getDate()).slice(-2);
    const hours   = ('0' + d.getHours()).slice(-2);
    const minutes = ('0' + d.getMinutes()).slice(-2);
    const seconds = ('0' + d.getSeconds()).slice(-2);
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.000`;
}

  export function numericInputLimit(event: Event, maxValue: number, maxDecimals: number, allowNegative: boolean = false): string{
    const input = event.target as HTMLInputElement;
    let val = input.value;
    let isNegetive = false;
    if (allowNegative && val.startsWith('-')) {
      isNegetive = true;
    }

    if (maxDecimals === 0) {
      val = val.replace(/[^0-9]/g, '');
    } else {
      val = val.replace(/[^0-9.]/g, '');
    }
    const points = val.split('.');
    if (points.length > 2) {
      val = points[0] + '.' + points.slice(1).join('');
    }
    if(isNegetive){
      val = '-'+val;
    }
    
    const maxIntegerLength = maxValue.toString().length;
    const parts = val.replace('-', '').split('.');
    let intPart = parts[0];
    let decPart = parts.length > 1 ? parts[1] : null;

    if (intPart.length > maxIntegerLength) {
      intPart = intPart.substring(0, maxIntegerLength);
      val = decPart !== null ? `${isNegetive ? '-' : ''}${intPart}.${decPart}` : `${isNegetive ? '-' : ''}${intPart}`;
    }
    
    if (decPart !== null && decPart.length > maxDecimals) {
      decPart = decPart.substring(0, maxDecimals);
      val = `${isNegetive ? '-' : ''}${intPart}.${decPart}`;
    }

    return val;
  }

  export function handleDateKeydown(event: KeyboardEvent): void {
    // 1. Define allowed navigation/edit keys
    const allowedKeys = [
      'Backspace', 'Tab', 'End', 'Home', 
      'ArrowLeft', 'ArrowRight', 'Delete', 
      'Enter', '/', '-', 'Control', 'Meta', 'a', 'c', 'v', 'x' // Allow Ctrl/Cmd and Shift for shortcuts
    ];
  
    // 2. Allow numbers 0-9
    const isNumber = /[0-9]/.test(event.key);
  
    // 3. Block if not a number and not an allowed special key
    if (!isNumber && !allowedKeys.includes(event.key)) {
      event.preventDefault();
      return;
    }
  
    // 4. Logic to prevent more than 4 digits in the year part
    // Only check if it's not a control key like Backspace or Tab
    const input = event.target as HTMLInputElement;
    if(input.selectionStart !== input.selectionEnd) return; // Just a safety check
    if (isNumber || event.key === '/') {
      const value = input.value;
      if (value.includes('/')) {
        const parts = value.split('/');
        if (parts.length === 3) {
          const yearPart = parts[2];
          if (yearPart.length >= 4 && isNumber) {
            event.preventDefault();
          }
        }
      }
    }
  }
  export const dateRangeCompleteValidator: ValidatorFn = (group: AbstractControl): ValidationErrors | null => {
    const start = group.get('start')?.value;
    const end = group.get('end')?.value;

    if(!start && !end){
      return {required: true}; // Let the required validators handle this case
    }
  
    if (start && !end) {
      return { incompleteRange: true };
    }
  
    if (!start && end) {
      return { incompleteRange: true };
    }
  
    return null;
  }

  export function strictDateValidator(control: AbstractControlDirective | AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (!value) return null; // Let required validator handle empty case
    const date = new Date(value);
    if (isNaN(date.getTime())) {
      return { invalidDate: true };
    }
    return null;
  }